import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ReferralsApplicationAnswersEffects } from './application-answers/application-answers.effects';
import {
  ReferralsApplicationAnswersNamespace,
  ReferralsApplicationAnswersReducer,
} from './application-answers/application-answers.store';
import { ReferralsApplicationsEffects } from './applications/applications.effects';
import {
  ReferralsApplicationsNamespace,
  ReferralsApplicationsReducer,
} from './applications/applications.store';
import { ReferralsAssignedOffersEffects } from './assigned-offers/assigned-offers.effects';
import {
  ReferralsAssignedOffersNamespace,
  ReferralsAssignedOffersReducer,
} from './assigned-offers/assigned-offers.store';
import {
  CandidateReferrerNamespace,
  CandidateReferrerReducer,
} from './candidate-referrers/candidate-referrers.store';
import { ReferralsClaimCountersEffects } from './claim-counters/claim-counters.effects';
import {
  ReferralsClaimCounterNamespace,
  ReferralsClaimCounterReducer,
} from './claim-counters/claim-counters.store';
import { ReferralsConditionsCollectionEffects } from './conditions-collection/conditions-collection.effects';
import {
  ReferralsConditionsCollectionNamespace,
  ReferralsConditionsCollectionReducer,
} from './conditions-collection/conditions-collection.store';
import { ReferralsOfferAssignmentEffects } from './offer-assignment/offer-assignment.effects';
import {
  ReferralsOfferAssignmentNamespace,
  ReferralsOfferAssignmentReducer,
} from './offer-assignment/offer-assignment.store';
import { ReferralsReferrerEffects } from './referrers/referrers.effects';
import { ReferralsReferrerNamespace, ReferralsReferrerReducer } from './referrers/referrers.store';
import { ReferralsRewardEffects } from './reward/reward.effects';
import { ReferralsRewardNamespace, ReferralsRewardReducer } from './reward/reward.store';
import { ReferralsSettingsEntityEffects } from './settings-entity/settings-entity.effects';
import {
  ReferralsSettingsEntityNamespace,
  ReferralsSettingsEntityReducer,
} from './settings-entity/settings-entity.store';
import { ReferralsTemplateItemEffects } from './template-item/template-item.effects';
import {
  ReferralsTemplateItemNamespace,
  ReferralsTemplateItemReducer,
} from './template-item/template-item.store';
import { ReferralsTemplateEffects } from './templates/templates.effects';
import { ReferralsTemplateNamespace, ReferralsTemplateReducer } from './templates/templates.store';
import { ReferralsTermsCollectionEffects } from './terms-collection/terms-collection.effects';
import {
  ReferralsTermsCollectionNamespace,
  ReferralsTermsCollectionReducer,
} from './terms-collection/terms-collection.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([
      ReferralsSettingsEntityEffects,
      ReferralsTermsCollectionEffects,
      ReferralsConditionsCollectionEffects,
      ReferralsApplicationsEffects,
      ReferralsClaimCountersEffects,
      ReferralsOfferAssignmentEffects,
      ReferralsReferrerEffects,
      ReferralsRewardEffects,
      ReferralsTemplateEffects,
      ReferralsTemplateItemEffects,
      ReferralsAssignedOffersEffects,
      ReferralsApplicationAnswersEffects,
    ]),
    StoreModule.forFeature(ReferralsSettingsEntityNamespace, ReferralsSettingsEntityReducer),
    StoreModule.forFeature(ReferralsTermsCollectionNamespace, ReferralsTermsCollectionReducer),
    StoreModule.forFeature(CandidateReferrerNamespace, CandidateReferrerReducer),
    StoreModule.forFeature(
      ReferralsConditionsCollectionNamespace,
      ReferralsConditionsCollectionReducer,
    ),
    StoreModule.forFeature(ReferralsApplicationsNamespace, ReferralsApplicationsReducer),
    StoreModule.forFeature(ReferralsClaimCounterNamespace, ReferralsClaimCounterReducer),
    StoreModule.forFeature(ReferralsOfferAssignmentNamespace, ReferralsOfferAssignmentReducer),
    StoreModule.forFeature(ReferralsReferrerNamespace, ReferralsReferrerReducer),
    StoreModule.forFeature(ReferralsRewardNamespace, ReferralsRewardReducer),
    StoreModule.forFeature(ReferralsTemplateNamespace, ReferralsTemplateReducer),
    StoreModule.forFeature(ReferralsTemplateItemNamespace, ReferralsTemplateItemReducer),
    StoreModule.forFeature(ReferralsAssignedOffersNamespace, ReferralsAssignedOffersReducer),
    StoreModule.forFeature(
      ReferralsApplicationAnswersNamespace,
      ReferralsApplicationAnswersReducer,
    ),
  ],
})
export class ReferralsDataModule {}
